// Login button for Studio1 Alpha
// Redirects to backend WorkOS OAuth flow

import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { logger } from "../../services/logger";
import { generateUUID } from "../../utils/uuid";

const BACKEND_API_URL =
  import.meta.env.VITE_BACKEND_API_URL || "http://localhost:3000";

interface LoginButtonProps {
  className?: string;
}

export const LoginButton: React.FC<LoginButtonProps> = ({ className = "" }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const handleLogin = () => {
    setLoading(true);
    const correlationId = generateUUID();

    logger.info("Login button clicked, redirecting to WorkOS", {
      correlationId,
    });

    // ProtectedRoute saves the original deep link in location.state.from
    // Reconstruct the full URL (path + search + hash) from it
    const from = (
      location.state as {
        from?: { pathname?: string; search?: string; hash?: string };
      }
    )?.from;
    const returnTo = from?.pathname
      ? from.pathname + (from.search ?? "") + (from.hash ?? "")
      : undefined;
    const returnToParam = returnTo
      ? `?returnTo=${encodeURIComponent(returnTo)}`
      : "";

    // Redirect to backend login endpoint (with optional returnTo)
    // Backend will store returnTo in state cookie and redirect to WorkOS OAuth
    window.location.href = `${BACKEND_API_URL}/v1/auth/login${returnToParam}`;
  };

  return (
    <div className={className}>
      <button
        onClick={handleLogin}
        disabled={loading}
        className="w-full flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg shadow-sm bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {loading ? (
          <>
            <Loader2 className="w-5 h-5 mr-3 animate-spin" />
            Connecting...
          </>
        ) : (
          "Sign In"
        )}
      </button>
    </div>
  );
};
